import axios from "axios";
import { useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const sameHost = !BACKEND || new URL(BACKEND).host === window.location.host;
// Custom domains (e.g. go.therehablabsg.com) route /api through the same ingress, so use same-origin there.
export const API = sameHost || window.location.hostname === "localhost" ? `${BACKEND}/api` : "/api";
export const TOKEN_KEY = "am_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const errDetail = (e) => e?.response?.data?.detail;
export const errCode = (e) => errDetail(e)?.code;
export const errMsg = (e) => {
  const d = errDetail(e);
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return JSON.stringify(d);
};

export function usePolling(fn, active, ms = 3000) {
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(fn, ms);
    return () => clearInterval(id);
  }, [fn, active, ms]);
}

export const fmtMoney = (v, cur = "SGD") => {
  if (v == null) return "—";
  const n = new Intl.NumberFormat("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
  return (cur || "SGD") === "SGD" ? `S$${n}` : `${cur} ${n}`;
};
export const fmtNum = (v) => (v == null ? "—" : new Intl.NumberFormat("en-SG", { maximumFractionDigits: 2 }).format(v));
export const fmtCid = (id) => (id ? String(id).replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : "");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-SG", { dateStyle: "medium", timeStyle: "short" }) : "—");
